export default __webpack_public_path__ + "generational-wealth.png";